<template>
  <fetch-story
    :route="cms.api_endpoint"
    :params="{
      sort_by: cms.api_order_by || null,
      by_uuids: cms.api_filter || null,
      filter_query: {
        thumbnails: {
          not_in: null,
        },
      },
    }"
    :limit="parseInt(cms.api_limit) || 0"
    :offset="parseInt(cms.api_offset) || 0"
    :collection="cms.slides"
    entry="content"
  >
    <grid
      v-editable="cms"
      slot-scope="{ collection }"
      html-tag="section"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          rows: 'repeat(1, auto)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          rows: 'repeat(1, auto)',
          gap: '10px',
        },
      ]"
      :class="[name]"
      :style="mainCssVars"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__media`]"
        :layout="[
          { size: 1, x: 1, width: 12, y: 1, height: 1 },
          { size: 3, x: 1, width: 24, y: 1, height: 1 },
        ]"
      >
        <vue-slick-carousel
          v-if="(collection || []).length > 0"
          ref="carousel"
          v-bind="{
            slidesToShow: carousel.slidesToShow,
            arrows: carousel.arrows,
            infinite: carousel.infinite,
            mobileFirst: carousel.mobileFirst,
            lazyLoad: carousel.lazyLoad,
          }"
          :class="`${name}__carousel`"
          @afterChange="onAfterChange"
          @init="onInit"
        >
          <div
            v-for="(item, index) in setThumbnail(collection)"
            :key="index"
            :class="`${name}__slide`"
            :style="{
              backgroundImage: 'url(' + item.image2.filename + ')',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }"
            @click="handleClick(item)"
            @mouseover="pauseAutoplay(true)"
            @mouseleave="pauseAutoplay(false)"
          ></div>
        </vue-slick-carousel>
      </grid-item>
      <grid-item
        :class="[`${name}__grid-item`, `${name}__misc`]"
        style="z-index: 1"
        :layout="[
          { size: 1, x: 1, width: 12, y: 1, height: 1 },
          { size: 3, x: 1, width: 24, y: 1, height: 1 },
        ]"
      >
        <grid
          html-tag="div"
          :class="['grid--container', `${name}__grid`]"
          :layout="[
            {
              size: 1,
              columns: 'repeat(12, 1fr)',
              gap: '6px',
            },
            {
              size: 2,
              columns: 'repeat(24, 1fr)',
              gap: '10px',
            },
          ]"
        >
          <grid-item
            v-if="show"
            :class="`${name}__grid-item`"
            :layout="[
              { size: 1, x: 1, width: 12 },
              { size: 3, x: 1, width: 24 },
            ]"
          >
            <component
              :is="item.component"
              v-for="(item, index) in cms.nav"
              :key="index"
              v-editable="item"
              :cms="item"
              :collection="collection"
              :carousel="carousel"
              :autoplay="autoplay && !carousel.paused"
              :class="`${name}__nav`"
              @on-next-slide="onNextSlide"
              @on-prev-slide="onPrevSlide"
            />
          </grid-item>
        </grid>
      </grid-item>
    </grid>
  </fetch-story>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import data from '~/components/organisms/o-carousel/o-carousel-v2.data'
import ASvgDots from '~/components/atoms/a-svgs/a-svg-dots'
import MThumbnailV2 from '~/components/molecules/m-slide/m-slide-v2'
import FetchStory from '~/components/shared/fetch-story'
import Colors from '~/mixins/colors'
import Thumbnail from '~/mixins/thumbnail'
import Href from '~/mixins/href'
export default {
  components: {
    FetchStory,
    VueSlickCarousel,
    ASvgDots,
    MThumbnailV2,
    'm-slide-v2': MThumbnailV2,
  },
  mixins: [Colors, Href, Thumbnail],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-carousel-v2',
      show: false,
      carousel: {
        slidePage: 0,
        slidesToShow: 1,
        arrows: false,
        infinite: true,
        mobileFirst: true,
        lazyLoad: 'ondemand',
        paused: false,
      },
    }
  },

  computed: {
    autoplay() {
      return this.cms.slide_autoplay
    },
    mainCssVars() {
      return {
        top: '73px',
        'z-index': '-1000',
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#000000',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#FFFFFF'
        ),
        '--hover-color': this.setColor('#FF3476'),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--filter': this.cms.filter || null,
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },

  async beforeCreate() {
    await this.$store.dispatch('loading/startBusyState')
  },

  methods: {
    setCta(page) {
      return (this.cms.cta || []).map((item) => {
        return !item.href.url && !item.href.cached_url
          ? {
              ...item,
              href: { cached_url: page.url },
            }
          : item
      })
    },
    handleClick(item) {
      const cta = this.setCta(item)
      const target = cta[0].href?.cached_url ? cta[0].href.cached_url : '/'
      window.location = window.location.origin + '/' + target
    },
    onInit() {
      this.show = true
      this.$store.dispatch('loading/stopBusyState')
    },
    pauseAutoplay(value) {
      this.carousel.paused = value
    },
    onAfterChange(slideNo) {
      this.carousel.slidePage = slideNo
    },
    onNextSlide(nextPage) {
      this.$refs.carousel.goTo(nextPage)
    },
    onPrevSlide(prevPage) {
      this.$refs.carousel.goTo(prevPage)
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slick-slider {
  display: grid;
  // Css grid defect with min-width 0 and 1fr. Set to min of 361px.
  grid-template-columns: minmax(320px, 1fr);
}

.slick-track {
  min-width: 0;
}

.slick-slide,
.slick-slide div {
  outline: none;
}

.o-carousel-v2 {
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  display: grid;
  height: 100%;
  cursor: pointer;
  aspect-ratio: 16 / 9;

  ::v-deep a,
  ::v-deep .a-cta,
  ::v-deep button {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  ::v-deep img {
    filter: var(--filter);
  }

  &__slide {
    height: 100%;
    aspect-ratio: 16 / 9;
  }

  &__carousel {
    height: inherit;
  }

  ::v-deep img,
  &__misc {
    pointer-events: none;
  }

  &__misc &__grid {
    height: 100%;
  }

  &__misc &__grid-item {
    position: relative;
  }

  &__nav {
    display: flex;
    justify-content: space-between;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-35%);
    width: 100%;
  }
}

@include media-breakpoint-up(sm) {
  .o-carousel-v2 {
    &__nav {
      top: 50%;
    }
  }
}

@include media-breakpoint-up(md) {
  .o-carousel-v2 {
    &__nav {
      top: 50%;
    }
  }
}
</style>
